import React, { useState, useContext } from "react";

import BannerSection from "../../inc/BannerSection";
import Banner from "../../images/banner.jpg";
import NotiIcon1 from "../../images/noti1.svg";
import NotiIcon2 from "../../images/noti2.svg";
import NotiIcon3 from "../../images/noti3.svg";
import Form from "react-bootstrap/Form";
import TherapistSidebar from "../../inc/TherapistSidebar";
import { Link } from "react-router-dom";
import { FaAlignLeft } from "react-icons/fa";
import { AuthContext } from "../../../utility/services/AuthContext";
import ApiService from "../../../utility/services/ApiService";
import Functions from "../../../utility/services/Functions";

const NotificationSettings = () => {
  // DATA VARIABLES

  const { user, setUser } = useContext(AuthContext);
  const userDetails = user.details;

  const [push_notifications, setPushNotifications] = useState(
    userDetails.push_notifications
  );
  const [text_notifications, setTextNotifications] = useState(
    userDetails.text_notifications
  );
  const [email_notifications, setEmailNotifications] = useState(
    userDetails.email_notifications
  );

  const [push_notifications_loading, setPushNotificationsLoading] =
    useState(false);
  const [text_notifications_loading, setTextNotificationsLoading] =
    useState(false);
  const [email_notifications_loading, setEmailNotificationsLoading] =
    useState(false);

  // LOGICAL VARIABLES

  const [filterHideShow, setfilterHideShow] = useState(false);

  const { select_notification_method } = ApiService();
  const { consoleService, set_user_details } = Functions();

  // FUNCTIONS

  const sideBarHide = () => {
    setfilterHideShow(!filterHideShow);
  };

  const setNotificationMethod = async (notification_type) => {
    try {
      const data = {
        push_notifications,
        text_notifications,
        email_notifications,
      };

      switch (notification_type) {
        case "push_notification":
          setPushNotificationsLoading(true);
          data.push_notifications = !push_notifications;
          const notfication_res = await select_notification_method(data);
          if (notfication_res.status === 1) {
            setPushNotifications(!push_notifications);
            await set_user_details();
            setPushNotificationsLoading(false);
          }

          break;
        case "text_notification":
          setTextNotificationsLoading(true);
          data.text_notifications = !text_notifications;
          const text_notification_res = await select_notification_method(data);
          if (text_notification_res.status === 1) {
            setTextNotifications(!text_notifications);
            await set_user_details();
            setTextNotificationsLoading(false);
          }

          break;
        case "email_notifications":
          setEmailNotificationsLoading(true);
          data.email_notifications = !email_notifications;
          const email_notification_res = await select_notification_method(data);
          if (email_notification_res.status === 1) {
            setEmailNotifications(!email_notifications);
            await set_user_details();
            setEmailNotificationsLoading(false);
          }
      }
    } catch (err) {
      consoleService("error in set notifications method", err);
    }
  };

  return (
    <>
      <div className="breadHidePhone">
        <BannerSection
          banner={Banner}
          name={"Home"}
          title={"Notification Settings"}
        />
      </div>
      <section className="py-5 useraccount bg-light_dash">
        <div className="container">
          <div className="row">
            <div
              className={`col-xl-3 col-md-4 ${
                filterHideShow ? "leftShow" : "leftHide"
              }`}
            >
              <TherapistSidebar />
            </div>
            <div className="col-xl-9 col-md-8 fulltabBox">
              <div className="filterBox">
                <Link className="filterIcon" onClick={sideBarHide}>
                  <FaAlignLeft />
                </Link>
              </div>
              <div className="dashboard-widg-bar d-block">
                <div className="dashboard_body">
                  <h4 className="mb-4 ft-medium">Notification Settings</h4>
                  <Form>
                    <div className="noti_setting">
                      <div
                        className="noti_setting ps-0"
                        style={{ opacity: push_notifications ? 1 : 0.4 }}
                      >
                        <img src={NotiIcon1} alt="" className="img-fluid" />
                        <div>
                          <h2>Push notifications</h2>
                          <p>Receive app push notifications</p>
                        </div>
                      </div>

                      <Form.Check // prettier-ignore
                        type="switch"
                        id="custom-switch"
                        label=""
                        size={"lg"}
                        checked={push_notifications}
                        value={push_notifications}
                        disabled={push_notifications_loading}
                        onChange={() => {
                          setNotificationMethod("push_notification");
                        }}
                      />
                    </div>
                    {userDetails.phone && (
                      <div>
                        <div className="noti_setting">
                          <div
                            className="noti_setting ps-0"
                            style={{ opacity: text_notifications ? 1 : 0.4 }}
                          >
                            <img src={NotiIcon2} alt="" className="img-fluid" />
                            <div>
                              <h2>Text notifications</h2>
                              <p>Receive text notifications on phone</p>
                            </div>
                          </div>

                          <Form.Check // prettier-ignore
                            type="switch"
                            id="custom-switch"
                            label=""
                            size={"lg"}
                            checked={text_notifications}
                            value={text_notifications}
                            disabled={text_notifications_loading}
                            onChange={() => {
                              setNotificationMethod("text_notification");
                            }}
                          />
                        </div>
                        <div
                          className={`flexNoti ${
                            !text_notifications && "flexNotiOpacity"
                          } `}
                        >
                          <Form.Check type={"checkbox"} checked={true} />
                          <p className="agree_txt_msg">
                            I agree to receive marketing messages from Twilio at
                            the phone number you provided on signup. Please note
                            data rates may apply, reply STOP to opt out.
                          </p>
                        </div>
                      </div>
                    )}

                    <div className="noti_setting">
                      <div
                        className="noti_setting ps-0"
                        style={{ opacity: email_notifications ? 1 : 0.4 }}
                      >
                        <img src={NotiIcon3} alt="" className="img-fluid" />
                        <div>
                          <h2>Email notifications</h2>
                          <p>Receive email notifications</p>
                        </div>
                      </div>

                      <Form.Check // prettier-ignore
                        type="switch"
                        id="custom-switch"
                        label=""
                        size={"lg"}
                        checked={email_notifications}
                        value={email_notifications}
                        disabled={email_notifications_loading}
                        onChange={() => {
                          setNotificationMethod("email_notifications");
                        }}
                      />
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotificationSettings;
